import _withProps from "recompose/withProps";
import { SearchField } from '@nextiva/next-ui';
export default _withProps({
  containerClassName: 'nx-table__search-field',
  inputClassName: 'nx-table__search-field__textfield'
})(SearchField);